








































































import { Component, Vue, Watch, Mixins, Prop } from 'vue-property-decorator'
import VisitorApi from '@/api/visitor'
import PartnerApi from '@/api/partner'
import PageLayout from '@/components/page/PageLayout.vue'
import listMixins from '@/mixins/list'

@Component({
	components: {
		PageLayout,
	},
})
export default class commentList extends Mixins(listMixins) {
	private data: any[] = []
	private visible: boolean = false
	private columns: any = [
		{
			title: '序号',
			dataIndex: 'key',
			align: 'center',
			width: 60,
		},
		{
			title: '任务类型',
			align: 'center',
			dataIndex: 'taskType',
			scopedSlots: { customRender: 'taskType' },
		},
		{
			title: '订单号',
			align: 'center',
			dataIndex: 'orderNo',
		},
		{
			title: '保司评分',
			align: 'center',
			dataIndex: 'evInsuranceScore',
			scopedSlots: { customRender: 'score' },
		},
		{
			title: '保司评价',
			align: 'center',
			dataIndex: 'evInsuranceComment',
			scopedSlots: { customRender: 'comment' },
		},
		{
			title: '伤者评分',
			align: 'center',
			dataIndex: 'evInjuryScore',
			scopedSlots: { customRender: 'score' },
		},
		{
			title: '伤者评价',
			align: 'center',
			dataIndex: 'evInjuryComment',
			scopedSlots: { customRender: 'comment' },
		},
		{
			title: '操作',
			align: 'center',
			key: 'operation',
			scopedSlots: { customRender: 'operation' },
		},
	]

	@Prop()
	private visitorId!: any

	@Watch('visitorId', { immediate: true })
	private onVisitorChange() {
		if (this.visitorId) {
			this.$nextTick(() => {
				this.getList()
			})
		}
	}

	public getList() {
		const form = this.getForm()
		form.visitorId = this.visitorId
		return VisitorApi.getCommentList(form).then((res: any) => {
			this.data = res.data.retList.map((item: any, index: number) => {
				let key: number = index + 1 + (this.current - 1) * this.pageSize
				return Object.assign({}, item, { key })
			})
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		return form
	}
}
